import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  Grid,
  Box,
} from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import axios from "axios";

export default function ShowLedDetails({ open, ledId, handleClose }) {
  const token = localStorage.getItem("token");
  const [LedData, setLedData] = useState([]);
  // handle show Led data ==========
  useEffect(() => {
    if (ledId) {
      handleShowData();
    }
  }, [ledId]);

  const handleShowData = async () => {
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + `/display/ledgerDetails`,
        { ledId },
        {
          headers: { Authorization: token },
        }
      );
      const LedData = response.data.vchType_Master[0];
      setLedData(LedData);
      // console.log(LedData);
    } catch (error) {
      console.error("Error updating voucher status:", error);
    }
  };
  return (
    <Box>
      <Dialog open={open} fullWidth maxWidth="md">
        <DialogTitle
          variant="h2"
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          Ledger Details
          <CancelIcon
            sx={{
              cursor: "pointer",
              fontSize: "32px",
              height: "30px",
              width: "30px",
              marginRight: "0px",
              marginTop: "0px",
            }}
            onClick={handleClose}
          />
        </DialogTitle>

        <DialogContent dividers>
          <Grid container spacing={2} mb={2}>
            <Grid item xs={6}>
              <TextField
                label="Name"
                value={LedData.led_Name}
                fullWidth
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Alias"
                value={LedData.led_Alias}
                fullWidth
                InputLabelProps={{ shrink: true }}
              />
            </Grid>

            <Grid item xs={6}>
              <TextField
                label="Parent"
                value={LedData.led_Parent}
                fullWidth
                InputLabelProps={{ shrink: true }}
              />
            </Grid>

            <Grid item xs={6}>
              <TextField
                label="Address"
                value={LedData.led_Address}
                fullWidth
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Country"
                value={LedData.led_Country}
                fullWidth
                InputLabelProps={{ shrink: true }}
              />
            </Grid>

            <Grid item xs={6}>
              <TextField
                label="State"
                value={LedData.led_State}
                fullWidth
                InputLabelProps={{ shrink: true }}
              />
            </Grid>

            <Grid item xs={6}>
              <TextField
                label="Pincode"
                value={LedData.led_Pincode}
                fullWidth
                InputLabelProps={{ shrink: true }}
              />
            </Grid>

            <Grid item xs={6}>
              <TextField
                label="PAN/IT No"
                value={LedData.led_Pan}
                fullWidth
                InputLabelProps={{ shrink: true }}
              />
            </Grid>

            <Grid item xs={6}>
              <TextField
                label="GST Reg Type"
                value={LedData.led_GSTReg}
                fullWidth
                InputLabelProps={{ shrink: true }}
              />
            </Grid>

            <Grid item xs={6}>
              <TextField
                label="GSTIN No"
                value={LedData.led_GSTIN}
                fullWidth
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </Box>
  );
}
